<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-backdrop" @click="visible = false" />
    <div v-if="visible" class="modal-sm" @keydown.enter="handleSave">
      <div class="modal-header">
        <span>Sauvegarder la recherche</span>
        <button class="close-btn" @click="visible = false">✕</button>
      </div>
      <div
        class="modal-body"
        style="display: flex; flex-direction: column; gap: 16px"
      >
        <div>
          <label class="field-label">Nom de la recherche</label>
          <input
            v-model="searchName"
            class="field-input"
            type="text"
            placeholder="Ex: CrossFit Paris 2026"
            autofocus
          />
        </div>
        <button
          class="btn btn-primary"
          style="width: 100%"
          :disabled="!searchName"
          @click="handleSave"
        >
          Ajouter →
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const visible = defineModel<boolean>('visible', { required: true });
const searchName = ref('');

const emit = defineEmits<{ save: [name: string] }>();

useEscapeKey(visible, () => {
  visible.value = false;
});

watch(visible, (v) => {
  if (!v) searchName.value = '';
});

function handleSave() {
  if (searchName.value.trim()) {
    emit('save', searchName.value.trim());
    searchName.value = '';
  }
}
</script>
